import { useState, useContext } from 'react';
import img1 from '../../images/1.png';
import img2 from '../../images/2.png';
import img3 from '../../images/8.png';
import img4 from '../../images/9.png';
import Objektangaben from './Objektangaben';
import { DataContext } from './../../App';

function Wohnung(params) {
  let [page, setPage] = useState(0);
  const { setType } = useContext(DataContext);

  let nextPage = (immobilienType) => {
    setPage(immobilienType);
    setType(immobilienType);
  };

  let previousPage = () => {
    setPage(0);
    setType();
  };

  return (
    <div>
      {page === 0 && (
        <>
          <h2>
            <strong>WELCHE IMMOBILIE MÖCHTEN SIE BEWERTEN?</strong>
            <hr />
          </h2>

          <div className='choices-list-four flex-container'>
            <div
              className='choice picture'
              onClick={() => nextPage('ERDGESCHOSS')}
            >
              <img
                height={'140px'}
                width={'140px'}
                src={img1}
                alt='ERDGESCHOSS'
              />
              <p>ERDGESCHOSS</p>
            </div>
            <div
              className='choice picture'
              onClick={() => nextPage('ETAGENWOHNUNG')}
            >
              <img
                height={'140px'}
                width={'140px'}
                src={img2}
                alt='ETAGENWOHNUNG'
              />
              <p>ETAGENWOHNUNG</p>
            </div>
            <div
              className='choice picture'
              onClick={() => nextPage('MAISONETTE')}
            >
              <img
                height={'140px'}
                width={'140px'}
                src={img3}
                alt='MAISONETTE'
              />
              <p>MAISONETTE</p>
            </div>
            <div
              className='choice picture'
              onClick={() => nextPage('DACHGESCHOSS')}
            >
              <img
                height={'140px'}
                width={'140px'}
                src={img4}
                alt='DACHGESCHOSS'
              />
              <p>DACHGESCHOSS</p>
            </div>
          </div>
          <div className='buttons'>
            <button className='previous' onClick={params.previousPage}>
              Zurück
            </button>
            <button className='next' onClick={() => setPage(1)}>
              Weiter
            </button>
          </div>
        </>
      )}
      {page !== 0 && <Objektangaben previousPage={previousPage} />}
    </div>
  );
}

export default Wohnung;
